import { Chip } from "@material-ui/core"
import { useLinked } from "@type-r/react"
import { CollapsableSection, Column, Flex, Input, PrimaryButton } from "lqx-react/lib"
import React from "react"
import { ActivationButton } from "../../../components/buttons"
import { Row } from "../../../components/item-card-styles"
import { StyledFormLabel } from "../../../components/number-input"
import { RightAlignedButtons } from "../../../shared"
import { FilterCriteriaSectionMapper } from "./filter-criteria-section-mapper"

export const FilterCriteriaSection = ({
    selectColumnMode,
    assetFilterCriteria,
    deleteColumnFilter
}: {
    selectColumnMode,
    assetFilterCriteria,
    deleteColumnFilter
}) => {
    const $selected = useLinked(false);
    const deleteFilter = (event) => {
        event.stopPropagation();
        deleteColumnFilter();
        $selected.set(false);
    }
    const activateSelection = (event) => {
        event.stopPropagation();
        selectColumnMode();
        $selected.set(!$selected.value);
    }
    const upsertFilterMapping = () => {
        selectColumnMode();
        $selected.set(!$selected.value);
    }
    return (
        <CollapsableSection
            title="Asset Filter Criteria"
            right={
                (!assetFilterCriteria.criteria || assetFilterCriteria.criteria.length === 0) &&
                <ActivationButton
                    {...{ active: $selected.value }}
                    onClick={(e) => activateSelection(e)}>
                    Select Column Header
                </ActivationButton>
            }
        >
            {assetFilterCriteria.filterColumn && assetFilterCriteria.filterColumn.name &&
                <Row>
                    <Flex row>
                        <Column>
                            <StyledFormLabel>Column Header</StyledFormLabel>
                        </Column>
                        <Column>
                            {$selected.value ?
                                <Chip
                                    label={assetFilterCriteria.filterColumn.name}
                                    color="primary"
                                    style={{ fontSize: "12px", color: "white" }}
                                    onDelete={(e) => deleteFilter(e)}
                                /> : <><Input disabled value={assetFilterCriteria.filterColumn.name} /></>}
                        </Column>
                    </Flex>
                </Row>
            }
            {assetFilterCriteria.criteria && assetFilterCriteria.criteria.map(item =>
                <FilterCriteriaSectionMapper criterian={item} disabled={!$selected.value} />
            )}
            {assetFilterCriteria.filterColumn && assetFilterCriteria.filterColumn.name ?
                <RightAlignedButtons>
                    <PrimaryButton color='green' onClick={upsertFilterMapping}>{$selected.value ? 'Apply' : 'Modify'}</PrimaryButton>
                </RightAlignedButtons>
                : <></>
            }

        </CollapsableSection>
    )
}